import { Box, useClipboard } from '@chakra-ui/react';
import { Button } from '@foam/buoy/src/components/Button/Button';
import { Icon } from '@foam/buoy/src/components/Icon/Icon';
import { IconButton } from '@foam/buoy/src/components/IconButton/IconButton';
import { toast } from '@foam/buoy/src/components/Toast/Toast';

export const ContactBtn = ({ email }: { email?: string }) => {
  const { onCopy } = useClipboard(email || '');

  const isDisabled = !email;

  const handleCopy = () => {
    onCopy();
    toast('Email copied to clipboard', {
      variant: 'success',
      duration: 3000,
    });
  };
  return (
    <>
      <Box
        display={{
          base: 'none',
          md: 'block',
        }}
      >
        <Button
          size="lg"
          onClick={handleCopy}
          track-id="contact-manager-btn"
          disabled={isDisabled}
        >
          <Icon name="Envelope" />
          Contact
        </Button>
      </Box>
      <Box
        display={{
          base: 'block',
          md: 'none',
        }}
      >
        <IconButton
          icon="Envelope"
          onClick={handleCopy}
          size="lg"
          track-id="contact-manager-btn"
          disabled={isDisabled}
        />
      </Box>
    </>
  );
};
